var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class ClientDebug {
    constructor() { this.keepFor = 15 * 60 * 1000; this.maxSize = 4000; this.oldBuffer = []; this.buffer = []; setInterval(() => { this.checkBuffer(); }, this.keepFor / 10); }
    checkBuffer() { const oldest = Date.now() - this.keepFor; this.buffer = this.buffer.filter(o => o.dateMs >= oldest); this.oldBuffer = this.oldBuffer.filter(o => o.dateMs >= oldest); }
    write(name) { for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    } this.buffer.push({ dateMs: Date.now(), name: name, args: args || [] }); if (this.buffer.length > this.maxSize / 2) {
        this.oldBuffer = this.buffer;
        this.buffer = [];
    } }
    makeTrace() { const lines = [...this.oldBuffer.map(b => { return [b.dateMs.toString(), b.name, ...this.argsToString(b.args)].join("\t") + "\n"; }), ...this.buffer.map(b => { return [b.dateMs.toString(), b.name, ...this.argsToString(b.args)].join("\t") + "\n"; })]; const blob = new Blob(lines, { type: "text/plain" }); return new File([blob], "log.txt", { type: "text/plain" }); }
    argsToString(input) {
        return input.map(i => {
            if (typeof i !== "object") {
                return makeString(i);
            } // 1-layer deep JSON encoded
            if (i instanceof Array) {
                return JSON.stringify(i.map(v => makeString(v)));
            }
            try {
                const keys = Object.keys(i);
                let obj = {};
                for (let i of keys) {
                    obj[i] = makeString(keys[i]);
                }
                return JSON.stringify(obj);
            }
            catch (e) {
                return "failed-to-encode:" + i;
            }
        });
    }
}
function makeString(input) { if (input === null)
    return "<null>"; if (input === undefined)
    return "<undefined>"; return input.toString(); }
export const clientDebug = new ClientDebug();
if (window.location.hostname !== "localhost") {
    const originalLog = console.log;
    console.log = function () { for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    } clientDebug.write("console.log", args); originalLog.apply(console, args); };
    const originalError = console.error;
    console.error = function () { for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
    } clientDebug.write("console.error", args); originalError.apply(console, args); };
    const originalWarn = console.warn;
    console.warn = function () { for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
    } clientDebug.write("console.warn", args); originalWarn.apply(console, args); };
    const originalDebug = console.debug;
    console.debug = function () { for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
    } clientDebug.write("console.debug", args); originalDebug.apply(console, args); };
    let fetchId = 0;
    const originalFetch = window.fetch;
    window.fetch = function () {
        var arguments_1 = arguments;
        return __awaiter(this, void 0, void 0, function* () { var _init; let url = undefined; let init = undefined; for (var _len6 = arguments_1.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            args[_key6] = arguments_1[_key6];
        } if (args.length > 0) {
            if (typeof args[0] === "string" || args[0] instanceof URL) {
                url = args[0].toString();
                if (args.length >= 2) {
                    init = args[1];
                }
            }
            else {
                const request = args[0];
                url = request.url;
                init = request;
            }
        } const method = ((_init = init) === null || _init === void 0 ? void 0 : _init.method) || "GET"; url = url || "<missing-url>"; fetchId++; const id = fetchId; clientDebug.write("fetch.start", ["id=" + id, method, url]); const tStart = Date.now(); let ok = false; try {
            const rs = yield originalFetch.apply(window, args);
            const dur = Date.now() - tStart;
            clientDebug.write("fetch.complete", ["id=" + id, "status=" + rs.status, "duration=" + dur + "ms"]);
            ok = true;
            return rs;
        }
        finally {
            if (!ok) {
                const dur = Date.now() - tStart;
                clientDebug.write("fetch.fail", ["id=" + id, "duration" + dur + "ms"]);
            }
        } });
    };
}
else {
    console.log("ClientDebug disabled");
}
